//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-stockout-apply-detail',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    FormComponent: FormComponent
  }
};